import { render, staticRenderFns } from "./LongzhouTeachingPage.vue?vue&type=template&id=f914707c&scoped=true"
import script from "./LongzhouTeachingPage.vue?vue&type=script&lang=js"
export * from "./LongzhouTeachingPage.vue?vue&type=script&lang=js"
import style0 from "./LongzhouTeachingPage.vue?vue&type=style&index=0&id=f914707c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f914707c",
  null
  
)

export default component.exports